export default __webpack_public_path__ + "static/media/btn_mas_info_az.a78e24c1.png";